import { ReactNode, useEffect, useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import "../../../utils/devtools";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
    },
  },
});

interface QueryProviderProps {
  children: ReactNode;
}

export function QueryProvider({ children }: QueryProviderProps) {
  const [showQueryDevtools, setShowQueryDevtools] = useState(false);

  useEffect(() => {
    const handleToggle = (event: CustomEvent) => {
      setShowQueryDevtools(event.detail);
    };

    window.addEventListener(
      "devtools-query-toggle",
      handleToggle as EventListener,
    );
    return () =>
      window.removeEventListener(
        "devtools-query-toggle",
        handleToggle as EventListener,
      );
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      {showQueryDevtools && <ReactQueryDevtools initialIsOpen={false} />}
    </QueryClientProvider>
  );
}
